import React, {

    useState,

    useEffect

} from "react";

import {

    FontAwesomeIcon

} from "@fortawesome/react-fontawesome";

import {

    CSSTransition

} from "react-transition-group";

import "./dashboardselector.css";

import DashboardSelectorRow

from "../components/DashboardSelectorRow";

import {

    TRUE

} from "../constants/general-constants";

import { OMNISCAN_BLUE } from "../constants/colors";


export default function DashboardSelector({

    title,

    childDashboards

})

{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [displayDropDown, setDisplayDropDown] =

        useState(false);

    const [displayDropDownChildren, setDisplayDropDownChildren] =

        useState(false);


    //--------------------------------------------------------
    // Reset when dashboard changes
    //--------------------------------------------------------

    useEffect(

        () =>

        {

            setDisplayDropDown(

                false

            );

            setDisplayDropDownChildren(

                false

            );

        },

        [title]

    );


    //========================================================
    // Styles
    //========================================================


    //--------------------------------------------------------
    // Complete selector
    //--------------------------------------------------------

    const thisContainer =

    {

        display:

            "flex",

        position:

            "fixed",

        top:

            "0px",

        left:

            "calc(50% - 300px)",

        flexDirection:

            "column",

        zIndex:

            "30000"

    };


    //--------------------------------------------------------
    // Main header
    //--------------------------------------------------------

	const primaryContainer =
	{
	    display:
	        "flex",

	    width:
	        "600px",

	    height:
	        "50px",

	    alignItems:
	        "center",

	    justifyContent:
	        "space-between",

	    boxSizing:
	        "border-box",

	    padding:
	        "0px 14px",

	    //----------------------------------------------------
	    // OmniScan Flat structural graphite
	    //----------------------------------------------------

	    background:
	        "linear-gradient(180deg,#171b20 0%,#0c0f12 100%)",

	    //----------------------------------------------------
	    // Structural container = square
	    //----------------------------------------------------

	    borderRadius:
	        "0px",

	    borderLeft:
	        "1px solid rgba(255,255,255,0.08)",

	    borderRight:
	        "1px solid rgba(255,255,255,0.08)",

	    borderTop:
	        "none",

			borderBottom:
			    `2px solid ${OMNISCAN_BLUE}`,

	    boxShadow:
	        "0 8px 20px rgba(0,0,0,0.20)",

	    zIndex:
	        "2"
	};


    //--------------------------------------------------------
    // Main title
    //--------------------------------------------------------

    const primaryLabel =

    {

        display:

            "flex",

        alignItems:

            "center",

        paddingLeft:

            "12px",

        fontSize:

            "16px",

        color:

            "#ffffff",

        width:

            "calc(100% - 60px)",

        fontWeight:

            "500",

        letterSpacing:

            "0.2px"

    };


    //--------------------------------------------------------
    // Left menu icon
    //--------------------------------------------------------

	const iconStyleLeft =
	{
	    color:
	        OMNISCAN_BLUE,

	    width:
	        "20px",

	    height:
	        "20px",

	    cursor:
	        "pointer"
	};


    //--------------------------------------------------------
    // Dropdown
    //--------------------------------------------------------

    const dropDownStyle =

    {

        pointerEvents:

            displayDropDownChildren

                ? "auto"

                : "none",

        width:

            "600px",

        boxSizing:

            "border-box",

        padding:

            "8px 0px",

        //----------------------------------------------------
        // Slightly deeper graphite than header
        //----------------------------------------------------

        background:

            `linear-gradient(
                180deg,
                #202428 0%,
                #121517 100%
            )`,

        borderRadius:

            "0px",

        borderLeft:

            "1px solid rgba(255,255,255,0.08)",

        borderRight:

            "1px solid rgba(255,255,255,0.08)",

        borderBottom:

            "1px solid rgba(255,255,255,0.08)",

        boxShadow:

            "0 10px 24px rgba(0,0,0,0.28)"

    };


    //========================================================
    // Dropdown
    //========================================================


    //--------------------------------------------------------
    // Main dropdown
    //--------------------------------------------------------

    const clickFunction =

        () =>

        {

            setDisplayDropDownChildren(

                false

            );

            setDisplayDropDown(

                prev => !prev

            );

        };


    //--------------------------------------------------------
    // Child dashboard dropdown
    //--------------------------------------------------------

    const clickFunctionChildren =

        () =>

        {

            setDisplayDropDown(

                false

            );

            setDisplayDropDownChildren(

                prev => !prev

            );

        };


    //--------------------------------------------------------
    // Dashboard icon
    //--------------------------------------------------------

    const getIcon =

        (index) =>

        {

            return index === 0

                ? "home"

                : "arrow-right";

        };


    //--------------------------------------------------------
    // Dashboard choices
    //--------------------------------------------------------

    const dashboardChoiceDisplayChildren =

        childDashboards.map(

            (item, index) => (

                <DashboardSelectorRow

                    key={

                        index

                    }

                    icon={

                        getIcon(index)

                    }

                    title={

                        item.title

                    }

                    isLive={

                        TRUE

                    }

                    url={

                        item.url

                    }

                    collapseFunction={

                        clickFunction

                    }

                />

            )

        );


    //========================================================
    // Render
    //========================================================

    return (

        <div

            style={

                thisContainer

            }

        >

            {/* ================================================
                HEADER
            ================================================= */}

            <div

                style={

                    primaryContainer

                }

            >

                <FontAwesomeIcon

                    icon="list-ul"

                    style={

                        iconStyleLeft

                    }

                    onClick={

                        clickFunctionChildren

                    }

                />


                <div

                    style={

                        primaryLabel

                    }

                >

                    {title}

                </div>

            </div>


            {/* ================================================
                CHILD DASHBOARDS
            ================================================= */}

            <CSSTransition

                in={

                    displayDropDownChildren

                }

                classNames="dashboardselector"

                timeout={

                    300

                }

                unmountOnExit

            >

                <div

                    className="dashboardselector"

                    style={

                        dropDownStyle

                    }

                    onClick={

                        (e) => e.stopPropagation()

                    }

                >

                    {dashboardChoiceDisplayChildren}

                </div>

            </CSSTransition>

        </div>

    );

}